import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyLetters]'
})
export class OnlyLettersDirective {

  @HostListener('input', ['$event'])
  onInputChange(event: InputEvent) {
    const inputElement = event.target as HTMLInputElement;

    // Remove non-letter, non-space characters
    let rawValue = inputElement.value.replace(/[^a-zA-Z\s]/g, '');

    // Capitalize each word while preserving original spacing
    const capitalized = rawValue.replace(/\b[a-z]/g, char => char.toUpperCase());

    if (inputElement.value !== capitalized) {
      inputElement.value = capitalized;

      // Update Angular form control
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype, 'value'
      )!.set!;
      nativeInputValueSetter.call(inputElement, capitalized);
      inputElement.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
